import React from 'react';

import Tooltip from 'components/Tooltip';

import contractRenewalIcon from 'assets/icons/contractRenewal.svg';

const RENEWAL_TOOLTIP = 'renewalIconTooltip';

const RenewalIcon = () => (
  <div>
    <div
      className="colab-sidepadding-1"
      data-tip="Renewal"
      data-for={RENEWAL_TOOLTIP}>
      <img src={contractRenewalIcon} alt="Contract Renewal Icon" />
    </div>

    <Tooltip place="right" effect="solid" id={RENEWAL_TOOLTIP} />
  </div>
);

export default RenewalIcon;
